import { Store, Module, ActionContext } from 'vuex';
import ListModule from './list-module';
import ListState from './list-state';
import Agency from '../entities/agency';

import Ajax from '../../lib/ajax';
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations';
import CurrentAccount from '../entities/finance/currentAccount';
import util from "../../lib/util";
interface AgencyState extends ListState<Agency> {
  agency: Agency;
  editAgency: Agency;
  select:Agency;
  currentAccounts: Array<CurrentAccount>,
  
}

class AgencyMutations extends ListMutations<Agency> {}

class AgencyModule extends ListModule<AgencyState, any, Agency> {
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<Agency>(),
    loading: false,
    editAgency: new Agency(),
    selectAgency: new Agency(),
    currentAccounts: new Array<CurrentAccount>(),
  };
  actions = {
    async selectAgency(context: ActionContext<AgencyState, any>, payload: any) {
      context.state.editAgency = payload.data;
    },

    async saveAgency(context: ActionContext<AgencyState, any>, payload: any) {
      let reponse = await Ajax.post(
        '/api/services/app/Agency/SaveAgency',
        payload.data
      );

      let page = reponse.data.result as PageResult<Agency>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },

    async addAgencyLimit(context: ActionContext<AgencyState, any>, payload: any) {
      let reponse = await Ajax.post(
        '/api/services/app/Admin/AddAgencyLimit',
        payload.data
      );

    },


    async updateAgency(context: ActionContext<AgencyState, any>, payload: any) {
      let reponse = await Ajax.put(
        '/api/services/app/Agency/UpdateAgency',
        payload.data
      );

      let page = reponse.data.result as PageResult<Agency>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async getAgencyInfo(context: ActionContext<AgencyState, any>, payload: any) {
      context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/Agency/GetAgencyInfo');
            context.state.loading = false;
            let agency = reponse.data.result as Agency;
            context.state.select = agency;
            if (agency && agency.id !== "4b065faa-61ad-4d82-83fa-abcdaa533389") {
              util.abp.auth.clearToken();
              location.reload();
          } 

    },

   async getAllCurrentAccounts(context: ActionContext<AgencyState, any>, payload: any){
          
    // context.state.loading=true;
     let reponse=await Ajax.get('/api/services/app/Admin/GetAllCurrentAccounts',payload.data);
   
    // context.state.loading=false;
     let page=reponse.data.result as PageResult<CurrentAccount>;
     context.state.totalCount=page.totalCount;
     context.state.currentAccounts=page.items;
 },

    async getAgency(context: ActionContext<AgencyState, any>, payload: any) {
      // context.state.loading=true;
      let reponse = await Ajax.get(
        '/api/services/app/Agency/GetAgency',
        payload.data
      );

      // context.state.loading=false;
      let page = reponse.data.result as PageResult<Agency>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },


    async deleteAgency(context: ActionContext<AgencyState, any>, payload: any) {
      await Ajax.delete(
        '/api/services/app/Agency/DeleteAgency?id=' + payload.payload
      );
    },
  };
  mutations = {
    setCurrentPage(state: AgencyState, page: number) {
      state.currentPage = page;
    },
    setPageSize(state: AgencyState, pagesize: number) {
      state.pageSize = pagesize;
    },
  };
}
const agencyModule = new AgencyModule();
export default agencyModule;
